import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import OrchestrateJourneysImage from './OrchestrateJourneysImage'

const copy = {
  heading: `Orchestrate journeys where the data is`,
  description: `Design personalized multichannel journeys using our drag-and-drop visual builder to automate messaging across paid and owned channels.`,
}
const link = {
  text: `Explore Journeys`,
  url: `/product/twilio-engage/journeys/`,
}

const features = [
  {
    heading: `Go from idea to campaign in minutes`,
    description: `Save time to execution by streamlining personalized journey creation and experimenting on new channels quickly.`,
  },
  {
    heading: `Analyze your multichannel journeys in one place`,
    description: `Track the performance of your multichannel campaigns, gain a high level view with Journey Analytics and set custom conversion goals to understand ROI performance—allowing you to truly understand your customer journey.`,
  },
  {
    heading: `Centrally manage omnichannel customer engagement campaigns at scale`,
    description: `Orchestrate and scale personalized campaigns everywhere your customers are using our <a href="https://segment.com/catalog/">${process.env.INTEGRATION_COUNT}+ out-of-the-box integrations</a>.`,
  },
]

const OrchestrateJourneys = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionWrapper variant="2Col">
      <StyledSectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>

        <ColumnTrackWrapper>
          <ColumnTrack gap="small">
            {features.map((feature, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text dangerouslySetInnerHTML={{ __html: feature.description }} />
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
        <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
      </StyledSectionCopy>

      <Section.Contents>
        <OrchestrateJourneysImage />
      </Section.Contents>
    </SectionWrapper>
  )
}

const SectionWrapper = styled(SectionBase)`
  overflow-x: visible;
`

const StyledSectionCopy = styled(Section.Copy)`
  direction: ltr;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    max-width: 440px;
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default OrchestrateJourneys
